// Queued body (DESIGN_SPEC §11.4.13): an empty specimen plate beside the identity sheets, then third-party analysis.
//   <QueuedView ctx />   FIG.01 Guest screen, an empty plate (s7, the 72-column moth) · identity (s5 side) ·
//                        FIG.02 Third-party: the lookups start while the run waits (absent while the backend has no intel)
// The record is polled every 2 s (useJob) until the run is dispatched and the stream opens.
import moth72 from "@/assets/specimen/moth-72.json";
import { Ascii, FigHead, Plate, PlateCap, Specimen } from "@/components/ui";
import type { ReportCtx } from "@/lib/derive/types";
import { IdentitySheets } from "./IdentitySheets";
import { ThirdPartySection } from "./panels/ThirdPartyFig";
import { FigRow } from "./ReportBody";

export function QueuedView({ ctx }: { ctx: ReportCtx }) {
  return (
    <div className="page">
      <FigRow>
        <section className="cell s7 fig" aria-labelledby="fig-1-t">
          <FigHead no={1} label="Guest screen" count="not booted" />
          <div className="fig-body">
            <Specimen label="An empty specimen plate" className="max-w-[440px]">
              <Plate sm>
                <Ascii art={moth72} maxPx={4.6} />
              </Plate>
            </Specimen>
            <PlateCap>queued · waiting for a {ctx.job.profile} slot</PlateCap>
          </div>
        </section>
        <aside className="cell s5 side" aria-label="Identity">
          <p className="subhead">Identity</p>
          <IdentitySheets job={ctx.job} staticReport={ctx.staticReport} stacked />
        </aside>
      </FigRow>
      {ctx.job.sample_sha && (
        <FigRow>
          <ThirdPartySection job={ctx.job} no={2} hideOff />
        </FigRow>
      )}
    </div>
  );
}
